import { render } from "./ProviderSearch.vue?vue&type=template&id=bda44f56&scoped=true"
import script from "./ProviderSearch.vue?vue&type=script&lang=js"
export * from "./ProviderSearch.vue?vue&type=script&lang=js"

import "@/assets/style/table.css?vue&type=style&index=0&lang=css"
import "./ProviderSearch.vue?vue&type=style&index=1&id=bda44f56&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda44f56"]])

export default __exports__